/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['#http-loader{top:0;left:0;height:100%;width:100%;position:fixed;z-index:9999}.loader-bg{height:100%;width:100%;position:absolute;filter:alpha(opacity=70);opacity:.7;background-color:#f1f1f1}.colored-parent,.colored>div{background-color:#333}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy9qb2JzL25vc3RyYS1tdWZpdC1pbmZvLXByb2Qvd29ya3NwYWNlL3NyYy9hcHAvc2hhcmVkL3NwaW5uZXIvc3Bpbm5lci5jb21wb25lbnQuY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvbGliL2plbmtpbnMvam9icy9ub3N0cmEtbXVmaXQtaW5mby1wcm9kL3dvcmtzcGFjZS9zcmMvYXBwL3NoYXJlZC9zcGlubmVyL3NwaW5uZXIuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/$$_gendir/app/shared/spinner/spinner.component.css.ngstyle.ts